<template>
  <div class="backgroud-white cs-courseSchedule-editor">
    <div class="backgroud-gray-popup popup-content-area-small">
      <el-form label-width="120px">
        <el-form-item label="学生">
          <span>{{ data.studentName }}</span>
        </el-form-item>
        <el-form-item label="课程">
          <span>{{ data.courseName }}</span>
        </el-form-item>
        <el-form-item label="复习课起止">
          <el-date-picker class="cs-reviewCourse-date" v-model="reviewCourseDate" type="daterange"
            align="center" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
            size="medium" :clearable="false">
          </el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer popup-footer">
      <el-row>
        <el-col class="footer-right" :span="24">
          <el-button @click="$emit('cancel')">取消</el-button>
          <el-button type="primary" :disabled="submitBtnDisable" @click="onSave">保存更新</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.cs-reviewCourse-date {
  width: 380px;
}

/deep/ .cs-reviewCourse-date .el-range-separator {
  width: 20px;
}

/deep/ .cs-reviewCourse-date .el-range__close-icon {
  display: none;
}
</style>

<script>
import { updateWorkflowCourseReviewDate } from "../../service/enrollmentFee.service";
import { formatDate } from "../../config/mUtils.js";

export default {
  props: {
    data: {
      id: Number,
      studentName: String,
      courseName: String,
      reviewCourseStart: String,
      reviewCourseEnd: String
    }
  },
  data() {
    return {
      submitBtnDisable: false,
      reviewCourseDate: []
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (this.data.reviewCourseStart && this.data.reviewCourseEnd) {
        this.reviewCourseDate = [new Date(this.data.reviewCourseStart), new Date(this.data.reviewCourseEnd)];
      } else {
        this.reviewCourseDate = [];
      }
    },
    onSave() {
      if (!this.reviewCourseDate || this.reviewCourseDate.length !== 2) {
        this.$message.error("请选择复习课起始日期范围");
        return;
      }
      let startDate = formatDate(this.reviewCourseDate[0]);
      let endDate = formatDate(this.reviewCourseDate[1]);
      this.$confirm(
        "您确定要保存复习课起始日期范围吗?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          this.submitBtnDisable = true;
          updateWorkflowCourseReviewDate(this.data.id, startDate, endDate).then(result => {
            if (!!result && result.success) {
              this.$message({
                message: "修改成功",
                type: "success"
              });
              this.$emit("success", { startDate, endDate });
            } else {
              this.$message.error("保存失败。" + result.message);
            }
            this.submitBtnDisable = false;
          }).catch(() => {
            this.submitBtnDisable = false;
          });
        })
        .catch(() => { });
    }
  },
  watch: {
    data: function () {
      this.init();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/studentProfile/reviewCourseDateEdit.vue